<template>
  <button
    type="button"
    :aria-label="checked ? 'סימון כלא בוצע' : 'סימון כבוצע'"
    :aria-pressed="checked"
    :disabled="disabled"
    class="task-checkbox"
    :class="[{ checked, small }]"
    @click.stop="emit('toggle')"
  >
    <i v-if="checked" class="pi pi-check" />
  </button>
</template>

<script setup lang="ts">
defineProps<{
  checked: boolean;
  small?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{ toggle: [] }>();
</script>

<style scoped lang="scss">
.task-checkbox {
  @apply flex-none flex items-center justify-center rounded-[7px] border-2 border-surface-300 bg-white text-white transition-colors;
  width: 24px;
  height: 24px;
  // The visible box is small; the hit area still reaches 40px.
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: -8px;
  }

  &.small {
    width: 20px;
    height: 20px;
    border-radius: 6px;
  }

  &.checked {
    @apply bg-primary border-primary;
  }

  i {
    font-size: 11px;
    font-weight: 700;
  }

  &:disabled {
    @apply opacity-50;
  }
}
</style>
